import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

// Selector de filtro en pantalla. options: string[] o [{ value, label }]. "todos" = sin filtro.
export default function FiltroSelect({ value, onChange, todosLabel, options = [], testid, className = "w-52" }) {
  const opts = options.map((o) => (typeof o === "string" ? { value: o, label: o } : o));
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={`h-9 ${className}`} data-testid={testid}><SelectValue /></SelectTrigger>
      <SelectContent>
        <SelectItem value="todos">{todosLabel}</SelectItem>
        {opts.map((o) => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}

export const labelDe = (value, options) => {
  if (value === "todos") return "";
  const o = options.find((x) => (typeof x === "string" ? x : x.value) === value);
  return typeof o === "string" ? o : o?.label || value;
};
